import { i18n } from '@/locales';
const listLc = 'views.baromoney-transfer-setting.';
/**
 * Enum 정의
 * 키워드 검색 항목
 */
export const keywordTypeEnum = {
    MEMO: 'MEMO',
    CREATED_BY_ID: 'CREATED_BY_ID',
    CREATED_BY_NAME: 'CREATED_BY_NAME',
};
/**
 * 진행상태 옵션
 */
export const statusEnum = {
    ALL: '',
    USE: 'USE',
    DELETE: 'DELETE',
    EXCLUDE_EXPIRED: 'EXCLUDE_EXPIRED',
};
/** 조회기준 옵션 */
export const searchTypeEnum = {
    ALL: 'ALL',
    SOURCE: 'SOURCE',
    TARGET: 'TARGET',
};
/** Options 구성 */
export const keywordTypeOptionList = [
    {
        text: i18n.t(`${listLc}keywordType.memo_search`),
        value: keywordTypeEnum.MEMO,
    },
    {
        text: i18n.t(`${listLc}keywordType.created_id_search`),
        value: keywordTypeEnum.CREATED_BY_ID,
    },
    {
        text: i18n.t(`${listLc}keywordType.created_name_search`),
        value: keywordTypeEnum.CREATED_BY_NAME,
    },
];
/**
 * 진행상태 옵션
 */
export const statusOptionList = [
    {
        text: i18n.t(`${listLc}status.all`),
        value: statusEnum.ALL,
    },
    {
        text: i18n.t(`${listLc}status.use`),
        value: statusEnum.USE,
    },
    {
        text: i18n.t(`${listLc}status.delete`),
        value: statusEnum.DELETE,
    },
    {
        text: i18n.t(`${listLc}status.exclude_expired`),
        value: statusEnum.EXCLUDE_EXPIRED,
    },
];
/** 조회기준 옵션 */
export const searchTypeOptionList = [
    {
        text: i18n.t('common.all'),
        value: searchTypeEnum.ALL,
    },
    {
        text: i18n.t(`${listLc}source`),
        value: searchTypeEnum.SOURCE,
    },
    {
        text: i18n.t(`${listLc}target`),
        value: searchTypeEnum.TARGET,
    },
];
